import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { resources } from '../../data/content';

const ResourceFilterMini = () => {
  const [activeTab, setActiveTab] = useState('All');
  const tabs = ['All', 'Strategy', 'AI', 'Operations'];
  
  const filtered = activeTab === 'All' 
    ? resources.slice(0, 3) 
    : resources.filter(r => r.category === activeTab).slice(0, 3);

  return (
    <div className="bg-white dark:bg-slate-900 rounded-2xl p-8 shadow-xl border border-slate-100 dark:border-slate-800">
      <div className="flex items-center justify-between mb-8">
        <div className="flex items-center gap-3">
          <div className="p-2 rounded-lg bg-brand-cyan/20">
            <SafeIcon name="Grid" className="w-6 h-6 text-brand-cyan" />
          </div>
          <h3 className="text-xl font-heading font-bold dark:text-white text-slate-900">Asset Library</h3>
        </div>
        <div className="flex gap-1 bg-slate-100 dark:bg-brand-dark p-1 rounded-lg">
          {tabs.map(tab => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-3 py-1 text-[9px] uppercase font-black rounded-md transition-all ${
                activeTab === tab 
                  ? 'bg-white dark:bg-slate-800 text-brand-cyan shadow-sm' 
                  : 'text-slate-400 hover:text-slate-600 dark:hover:text-white'
              }`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      <div className="space-y-4 min-h-[240px]">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="space-y-4"
          >
            {filtered.map(res => (
              <div key={res.id} className="flex items-center gap-4 p-4 border border-slate-50 dark:border-slate-800/50 rounded-xl hover:border-brand-cyan transition-colors group cursor-pointer">
                <div className="w-10 h-10 rounded-lg bg-slate-50 dark:bg-brand-darker flex items-center justify-center text-slate-400 group-hover:text-brand-cyan transition-colors">
                  <SafeIcon name={res.icon.replace('Fi', '')} className="w-5 h-5" />
                </div>
                <div className="flex-grow">
                  <h4 className="text-sm font-bold text-slate-900 dark:text-white mb-0.5">{res.title}</h4>
                  <p className="text-[10px] text-slate-500 font-medium uppercase tracking-widest">{res.type}</p>
                </div>
                <SafeIcon name="Download" className="w-4 h-4 text-slate-300 group-hover:text-brand-cyan transition-colors" />
              </div>
            ))}
            {filtered.length === 0 && (
              <div className="h-full flex flex-col items-center justify-center text-slate-400 py-12">
                <SafeIcon name="Inbox" className="w-8 h-8 mb-2 opacity-20" />
                <p className="text-xs font-bold uppercase tracking-widest">No assets in this category</p>
              </div>
            )}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default ResourceFilterMini;